import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}

export function formatDateTime(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleString('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function toRomanNumeral(num: number): string {
  const romanNumerals: [number, string][] = [
    [1000, 'M'],
    [900, 'CM'],
    [500, 'D'],
    [400, 'CD'],
    [100, 'C'],
    [90, 'XC'],
    [50, 'L'],
    [40, 'XL'],
    [10, 'X'],
    [9, 'IX'],
    [5, 'V'],
    [4, 'IV'],
    [1, 'I'],
  ];

  let result = '';
  for (const [value, numeral] of romanNumerals) {
    while (num >= value) {
      result += numeral;
      num -= value;
    }
  }
  return result;
}

export function getNeedleLabel(needle: 1 | 2 | 3): string {
  switch (needle) {
    case 1:
      return 'Nadel 1 - Grundunterlagen';
    case 2:
      return 'Nadel 2 - Vollstreckungsunterlagen';
    case 3:
      return 'Nadel 3 - Sonstige Schriftstücke';
  }
}

export function getProtectionLevelLabel(level: string): string {
  switch (level) {
    case 'NORMAL':
      return 'Normal';
    case 'CONFIDENTIAL':
      return 'Vertraulich';
    case 'STRICTLY_CONFIDENTIAL':
      return 'Streng vertraulich';
    default:
      return level;
  }
}
